import React, { useContext } from 'react';
import '../../assets/styles/OrdersTab.scss';
import { Box, Typography } from '@mui/material';
import { GaintOFDOrdersContext } from '../../context';

export default function OrdersTab() {
    const { tabOptions, activeTab, setActiveTab } = useContext(GaintOFDOrdersContext);

    return (
        <Box className="orders-tab-container">
            <Box className="orders-tab-scroll">
                {tabOptions.map((tab) => (
                    <Box
                        key={tab.value}
                        className={`orders-tab-item ${activeTab === tab.value ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.value)}
                    >
                        <Typography variant="body2">{tab.label}</Typography>
                        {activeTab === tab.value && <span className="active-indicator" />}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
